"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var Typename_1 = require("../../types/enums/Typename");
var dayjs_1 = __importDefault(require("dayjs"));
var constants_1 = require("./constants");
var selectors_1 = require("../customer/selectors");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
exports.accountPinValidation = reselect_1.createSelector(moduleState, selectors_1.selectedProfileId, function (state, profileId) {
    return profileId && state.accountPinValidation.data[profileId];
});
exports.pinValidationResult = reselect_1.createSelector(exports.accountPinValidation, function (pinValidation) { var _a; return (_a = pinValidation) === null || _a === void 0 ? void 0 : _a.pinValidationResult; });
exports.isLoadingValidation = reselect_1.createSelector(moduleState, function (state) { var _a; return (_a = state.accountPinValidation) === null || _a === void 0 ? void 0 : _a.isLoading; });
exports.validationError = reselect_1.createSelector(moduleState, function (state) { var _a; return (_a = state.accountPinValidation) === null || _a === void 0 ? void 0 : _a.error; });
exports.pinExpiry = reselect_1.createSelector(exports.accountPinValidation, function (pinValidation) {
    if (pinValidation) {
        var result = pinValidation.pinValidationResult, expiryDate = pinValidation.expiryDate;
        if (result.__typename === Typename_1.Typename.PinValidationResult && (result === null || result === void 0 ? void 0 : result.isValid)) {
            return expiryDate;
        }
    }
    return undefined;
});
exports.hasPinExpired = function (date) {
    return date ? dayjs_1.default().isAfter(date) : true;
};
//# sourceMappingURL=selectors.js.map